import React from 'react';

import { UndeliverableMailStatistic } from './components';
import { useGetUndeliverableURL, useUndeliverableMailStatisticLogic } from './hooks';
import { useGetUndeliverableMailStatisticQuery } from './queries';

const UndeliverableMailStatisticContainer: React.FC = () => {
  const { isLoading, data } = useGetUndeliverableMailStatisticQuery();
  const { count, isDetailsLinkVisible, isHidden } = useUndeliverableMailStatisticLogic({ data });
  const currentURL = useGetUndeliverableURL();
  if (isHidden) {
    return null;
  }

  return (
    <UndeliverableMailStatistic
      isLoading={isLoading}
      url={currentURL}
      count={count}
      isDetailsLinkVisible={isDetailsLinkVisible}
    />
  );
};

export default UndeliverableMailStatisticContainer;
